import { render, staticRenderFns } from "./TitleBarCard.vue?vue&type=template&id=dda2ced2&scoped=true"
import script from "./TitleBarCard.vue?vue&type=script&lang=js"
export * from "./TitleBarCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda2ced2",
  null
  
)

export default component.exports